import { CardLinkedOffersPageTemplate } from "./template";

export const CardLinkedOffersPage = (): JSX.Element => {
  return <CardLinkedOffersPageTemplate />;
};
